export class WebApiResponseBase {
    token: string;
    status: string;
    message: string;
};

export class WebApiResponse<T> extends WebApiResponseBase {
    payload: T;
};

export const ResponseStatusCodes = {
    OK: "OK",
    KO: "KO",
    NOAUTH: "NOAUTH",
}


// WEBPACK FOOTER //
// ./src/angular_library/models/web-api-response.ts